import { GetterTree } from "vuex";
import { RootState } from "@/store/modules/root/interfaces";
import { AIAssessmentState } from "./interfaces";

const getters: GetterTree<AIAssessmentState, RootState> = {
  aiIsLoading: (state) => state.isLoading,
  aiError: (state) => state.error,
  aiSessionId: (state) => state.sessionId,
  aiChatLog: (state) => state.chatLog,
  aiQuestions: (state) => state.questions,
  aiAssessmentData: (state) => state.assessmentData,
  aiShowResultModal: (state) => state.showResultModal,
  aiLoadingContext: (state) => state.loadingContext,
  aiIsEditMode: (state) => state.isEditMode,
  aiEditingQuestionIndex: (state) => state.editingQuestionIndex
};

export default getters;
